module.exports = __webpack_public_path__ + "img/kefuImg.e577e02b.png";